import axios from './axiosInstances/axiosInstance';
// import retrieveBasket from './retrieveBasket.json';

export const applyCouponToBasket = (basketId, coupon) => {
  return axios.put(`/baskets/${basketId}/coupon`, {
    couponcode: coupon,
  });
};
export default applyCouponToBasket;
